export default class sidebarBlockOverlay {
    constructor() {
        return {
            template: require('../../../../views/maileditor/sidebar-blockoverlay.html'),
            replace: true,
            restrict: 'E',
            controller: SidebarBlockOverlayCtrl,
            controllerAs: 'blockSettings'
        }
    }
};

class SidebarBlockOverlayCtrl {
    constructor($scope, $filter, SweetAlert) {
        this._scope = $scope;
        this._filter = $filter;

        this.sweetAlert = SweetAlert;

        this.showSettingsOverlay = false;
        this.showBlockOverlay = false;

        this._scope.$on('mailEditor:content:setLoaded', () => {
            this.contentLoaded = true;
        });

        this._scope.$on('mailEditor:settingsOverlay:toggle', (event, show) => {
            this.showSettingsOverlay = show;
        });

        this._scope.$on('mailEditor:state:saving', () => {
            this.showSettingsOverlay = false;
            this.showBlockOverlay = false;
        });
    }

    toggleBlock() {
        this.showBlockOverlay = ! this.showBlockOverlay;

        if (this.showBlockOverlay) {
            this.sweetAlert.swal({
                title: this._filter('translate')('MAILEDITOR_MODAL:DEPRECATED_CUSTOMIZE_BLOCK_TITLE'),
                html: true,
                text: this._filter('translate')('MAILEDITOR_MODAL:DEPRECATED_CUSTOMIZE_BLOCK_TEXT'),
                type: "info"
            });
        }

        this._scope.$emit('mailEditor:toggleBlockOverlay', this.showBlockOverlay);
    }

    toggleSettings() {
        if (! this.showBlockOverlay) {
            this.showSettingsOverlay = ! this.showSettingsOverlay;
            this._scope.$emit('mailEditor:toggleSettingsOverlay', this.showSettingsOverlay);
        }
    }
}
